export default __webpack_public_path__ + "static/media/123.52dd3fbf.gif";